import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { StatusReportSearchComponent } from '../shared-tlr-status-reports/status-report-search/status-report-search.component';
import { TableModule } from 'primeng/table';
import { ChartModule } from 'primeng/chart';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ReportService } from '../../../../services/report.service';
import { Subscription } from 'rxjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { saveAs } from 'file-saver';
import { CommonService } from '../../../../services/common.service';
@Component({
    selector: 'app-tlr-beyond-date-report',
    imports: [FormsModule, CommonModule,
        DropdownModule, CheckboxModule, ButtonModule, NextPage, StatusReportSearchComponent,
        TableModule, ChartModule,
        RouterModule],
    providers: [DatePipe],
    templateUrl: './tlr-beyond-date-report.component.html',
    styleUrl: './tlr-beyond-date-report.component.scss'
})
export class TlrBeyondDateReportComponent {
  isShowMainBlock: boolean = false;
  searchPageTitle: string = 'TLR\'s Beyond Due Date';
  filters: any;
  showDetailsBlock: boolean = false;
  isLoading: boolean = false;
  criteriaData: any;
  paramSub: Subscription | undefined;
  isDetailsBlock: boolean = false;
  titleName: string = '';
  tlrBeyondDueDateReport: any;
  beyondDueDateReportDataDetails: any;
  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y', // This makes the bar chart horizontal
    scales: {
      y: {
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          autoSkip: false, // Disable auto skipping of labels
          padding: 10,

          align: 'end',
          color: 'blue',
          font: {
            weight: 'bold',
            size: 12
          },
        },
        beginAtZero: true
      },
      x: {
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          autoSkip: false, // Disable auto skipping of labels
          color: 'black',
          align: 'center',
          font: {
            weight: 'bold'
          },
        },

      }
    },
    plugins: {

      title: {
        display: true,
        text: '',
        font: {
          size: 20
        },
        color: 'blue'
      }
      ,
      legend: {
        labels: {
          color: 'black',
          font: {
            weight: 'bold',
          }
        },
        position: 'bottom',
        display: false

      },


      //     categoryPercentage: 10, // Adjust this value to increase/decrease space between bars
      //     barPercentage: 0.9, // Adjust this value to increase/decrease bar width

      datalabels: {
        anchor: 'end',
        align: 'end',
        formatter: function (value: number, context: any) {
          return value.toString();
        },
        font: {
          weight: 'bold'
        }
      }
    }
  }
  plugins = [ChartDataLabels];

  chartData: {
    labels: any; datasets: any;
  } = {
      labels: undefined,
      datasets: undefined
    };
  constructor(public reportService: ReportService,
    private datePipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    // private reportService: ReportService,
    private commonService: CommonService
  ) {

  }

  queryParams: any = {};
  ngOnInit() {
    this.paramSub = this.route.queryParams.subscribe((params:any) => {

      this.filters = params;

      params['showMainBlock'] ? this.isShowMainBlock = true : this.isShowMainBlock = false;
      params['isDetailsBlock'] ? this.isDetailsBlock = true : this.isDetailsBlock = false;
      // if (!this.isShowMainBlock && !this.isDetailsBlock) {
      //   this.resetFilters();
      // }
      if (this.isShowMainBlock && this.isDetailsBlock) {
        this.titleName = params.titleName ? params.titleName : '';
        this.getDetailsData(this.titleName);
      }
      if (this.isShowMainBlock && !this.isDetailsBlock) {
        this.getReportData();
      }
    });


  }
  ngOnDestroy() {
    if (this.paramSub) {
      this.paramSub.unsubscribe();
    }
  }
 

  generateReport(event: any) {
    this.isShowMainBlock = true;
    const queryParams = { showMainBlock: true, ...event.filters, };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge', // This will merge the new query params with existing ones
      skipLocationChange: false // Set to true if you don't want to update the browser URL
    });
  }

  getReportData() {
    this.isLoading = true;
    let payload = {
      graphFlag: 'G',
      userCai: this.commonService.getUserCai(),
      facilityId: this.reportService.getCurrentFacilityId(),
      startDate: this.datePipe.transform(this.filters.startDate, 'yyyy-MM-dd'),
      endDate: this.datePipe.transform(this.filters.endDate, 'yyyy-MM-dd'),
      section: this.filters.section,
      plant: this.filters.plant,
      associatedUnit: this.filters.associatedUnit,
      division: this.filters.division,
      leakType: this.filters.manageLeaksItems,
      materialState: this.filters.materialStateItems,
      repairType: this.filters.repairType,
      services: this.filters.selctedServices,
      ldarFlag: this.filters.ldar
    };

    this.reportService.getTLRBeyondDateReport(payload).subscribe({
      next: (data: any) => {
        const greenGradient = 'rgba(134, 180, 42, 0.8)'; // Updated gradient to a solid green color with transparency
       const grayGradient = 'rgb(194 205 218)'; // Updated gradient to a solid gray color with transparency
        this.tlrBeyondDueDateReport = data;
        
        this.chartData = {
          labels: data?.map((d: any) => d.TitleName),
          datasets: [
            {
              label: 'Total',              
              data: data?.map((d: any) => Number(d.TitleNumber)),
              backgroundColor: data.map((d: any) => d.TitleName == 'No Recommended Repair Date' ? grayGradient : greenGradient),
              borderColor: "#c1b9b9",
              boxshadowColor: "#c1b9b9",
              borderRadius: 2,
              borderWidth: 2,
              align: 'middle',
              // barPercentage: 0.5, // Set the bar percentage  
              barThickness: 25, // Set the bar thickness
              maxBarThickness: 35, // Set the maximum bar thickness
              borderSkipped: false,
            },
          ]
        };
        const currentDate = this.datePipe.transform(new Date(), 'MM/dd/YYYY');
        this.chartOptions.plugins.title.text = ` 	TLR's Beyond Due Date - ${currentDate}`;
        this.isLoading = false;

      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
        this.isLoading = false; // Set loading to false on error
      }
    });
  }
  getDetails(title: any) {
    this.titleName = title;
    this.isDetailsBlock = true;
    this.isLoading = true;
    const queryParams = { isDetailsBlock: true, titleName: this.titleName };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge', // This will merge the new query params with existing ones
      skipLocationChange: false // Set to true if you don't want to update the browser URL
    });
  }

  getDetailsData(title: any) {
    let payload = {
      graphFlag: this.getGraphFlag(this.titleName),
      userCai: this.commonService.getUserCai(),
      facilityId: this.reportService.getCurrentFacilityId(),
      startDate: this.datePipe.transform(this.filters.startDate, 'yyyy-MM-dd'),
      endDate: this.datePipe.transform(this.filters.endDate, 'yyyy-MM-dd'),
      section: this.filters.section,
      plant: this.filters.plant,
      associatedUnit: this.filters.associatedUnit,
      division: this.filters.division,
      leakType: this.filters.manageLeaksItems,
      materialState: this.filters.materialStateItems,
      repairType: this.filters.repairType,
      services: this.filters.selctedServices,
      ldarFlag: this.filters.ldar
    };
    this.reportService.getTLRBeyondDateReport(payload).subscribe({
      next: (data: any) => {
        this.beyondDueDateReportDataDetails = data;
        this.isLoading = false; // Set loading to false when data is loaded successfully
      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
        this.isLoading = false; // Set loading to false on error
      }
    });
  }

  downloadExcel() {
    let payload = {
      graphFlag: this.getGraphFlag(this.titleName),
      userCai: this.commonService.getUserCai(),
      facilityId: this.reportService.getCurrentFacilityId(),
      startDate: this.datePipe.transform(this.filters.startDate, 'yyyy-MM-dd'),
      endDate: this.datePipe.transform(this.filters.endDate, 'yyyy-MM-dd'),
      section: this.filters.section,
      plant: this.filters.plant,
      associatedUnit: this.filters.associatedUnit,
      division: this.filters.division,
      leakType: this.filters.manageLeaksItems,
      materialState: this.filters.materialStateItems,
      repairType: this.filters.repairType,
      services: this.filters.selctedServices,
      ldarFlag: this.filters.ldar
    };
    this.reportService.getTlrBeyondDueDateDetailsExportExcel(payload)
      .subscribe({
        next: (fileData) => {
          if (fileData) {
            saveAs(fileData, 'TLR-BeyondDueDate.xlsx');
          }

        },
        error: (err) => {
          console.error('Error fetching report details:', err);
        }
      })

  }

  getGraphFlag(title: string) {
    switch (title.trim()) {
      case '> 90 Days (Future)':
        return '4';  // Gray
      case '> 30 Days (Future)':
        return '2';  // Red
      case '0 - 30 Days (Future)':
        return '0';  // Blue
      case 'No Recommended Repair Date':
        return 'N'; // Dark Blue
      case '1 - 30 Days (Behind)':
        return '1';  // Gray
      case '> 30 Days (Behind)':
        return '3';  // Red
      case '> 90 Days (Behind)':
        return '9';  // Blue
      case '> 180 Days (Behind)':
        return '8'; // Dark Blue
      case '> 1 Year (Behind)':
        return 'A'; // Dark Blue
      case '> 2 Years (Behind)':
        return 'B';  // Gray
      case '> 5 Years (Behind)':
        return 'C';  // Red
      default:
        return 'G';  // Default to Gray
    }
  }

  selectData(event: any) {
    const label = this.chartData.labels[event.element.index];
    this.getDetails(label);
  }

  getDateClass(date: Date): string {
    date = new Date(date); // Convert to Date object if it's a string
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for comparison

    if (date < today) {
      return 'past-date';
    } else  {
        return 'future-date';
      }
  }
}
